import { render } from "./FeedBack.vue?vue&type=template&id=06eab166&scoped=true"
import script from "./FeedBack.vue?vue&type=script&lang=js"
export * from "./FeedBack.vue?vue&type=script&lang=js"

import "./FeedBack.vue?vue&type=style&index=0&id=06eab166&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eab166"]])

export default __exports__